<ng-container *ngIf="registrationPageData">
<div class="app-logo">
  <a [routerLink]="icon.link" class="logo-link">
    <img [src]="icon.image" width="150" height="38" alt="Logo">
  </a>
</div>

<h3 class="form-title">
  <strong>{{registrationPageData.mainTitle}}</strong>
  <br/>
  {{registrationPageData.title}}
</h3>
<div class="form-description">
  {{registrationPageData.subTitle}}
</div>

<form [formGroup]="form" novalidate (submit)="onSubmit()">
  <mat-form-field appearance="outline" class="control-field">
    <mat-label>{{registrationPageData.usernamePlaceholder}}</mat-label>
    <input matInput formControlName="username">
    <mat-error *ngIf="form.controls['username'].hasError('required') && form.controls['username'].touched">
      {{registrationPageData.requiredUserNameText}}
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="control-field">
    <mat-label>{{registrationPageData.passwordPlaceholder}}</mat-label>
    <input matInput formControlName="password" type="password">
    <mat-error *ngIf="form.controls['password'].hasError('required') && form.controls['password'].touched">
      {{registrationPageData.requiredPasswordText}}
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>{{registrationPageData.idPlaceholder}}</mat-label>
    <input matInput formControlName="id">
    <mat-error *ngIf="form.controls['id'].hasError('required') && form.controls['id'].touched">
      {{registrationPageData.requiredIdText}}
    </mat-error>
    <!-- <mat-error *ngIf="form.controls['id'].touched && form.controls['id'].errors?.['invalidIDValidator']
    && !form.controls['id'].hasError('required')">
    {{registrationPageData.invalidIdText}}
  </mat-error> -->
  </mat-form-field>
  <mat-error class="login-error-message-container">
    <div class="error-color login-error-message login-otp-code">{{errorMessage}}</div>
  </mat-error>
  <!-- <div class="checkbox-control">
    <mat-checkbox formControlName="keepConnected">{{registrationPageData.keepConntectedText}}</mat-checkbox>
  </div> -->

  <div class="btn-box">
    <app-preloader *ngIf="isLoading" [miniPreloader]="true"></app-preloader>
    <button *ngIf="!isLoading" mat-flat-button color="primary" class="w-100">{{registrationPageData.submitButtonText}}</button>
  </div>
  
  <div class="links">
    <a href="{{registrationPageData.forgetPasswordLinkText.url}}" class="link"> {{registrationPageData.forgetPasswordLinkText.name}}</a>
    <a href="{{registrationPageData.systemRequirementsLinkText.url}}" class="link">{{registrationPageData.systemRequirementsLinkText.name}} </a>
  </div>
</form>
</ng-container>

<ng-container *ngIf="!registrationPageData">
  <div class="skeleton" aria-hidden="true">
    <div class="app-logo">
      <app-skeleton [height]="46"/>
    </div>
    
    <h3 class="form-title">
      <app-skeleton [symbolsCount]="50" type="text"/>
      <app-skeleton [symbolsCount]="50" type="text"/>
    </h3>
    <div class="form-description">
      <app-skeleton [symbolsCount]="100" type="text"/>
    </div>
    
    <form>
      <app-skeleton [height]="48" class="control-field"/>
      <div class="mat-mdc-form-field-subscript-wrapper"></div>
      <app-skeleton [height]="48" class="control-field"/>
      <div class="mat-mdc-form-field-subscript-wrapper"></div>
      <app-skeleton [height]="48" class="control-field"/>
      <div class="mat-mdc-form-field-subscript-wrapper"></div>
      <div class="mat-mdc-form-field-subscript-wrapper"></div>

      <div class="btn-box">
        <app-skeleton [height]="48"/>
      </div>
      
      <div class="links">
        <app-skeleton [additionalElementClasses]="['link']" [symbolsCount]="18" type="text"/>
        <app-skeleton [additionalElementClasses]="['link']" [symbolsCount]="18" type="text"/>
      </div>
    </form>
  </div>
</ng-container>